// extracted by mini-css-extract-plugin
module.exports = {"buttonAsA":"ButtonAsA_buttonAsA__3l7Ze"};